import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@mui/material";
import ExploreOffOutlinedIcon from "@mui/icons-material/ExploreOffOutlined";

const NotFound = () => (
  <main
    style={{
      minHeight: "100vh",
      display: "grid",
      placeItems: "center",
      padding: "var(--wg-space-8)",
    }}
  >
    <div className="wg-empty" style={{ maxWidth: 520, background: "var(--wg-surface)" }}>
      <span className="wg-empty__icon">
        <ExploreOffOutlinedIcon />
      </span>
      <p className="wg-eyebrow">Error 404</p>
      <h1 className="wg-empty__title" style={{ fontSize: "var(--wg-text-xl)" }}>
        We couldn’t find that page
      </h1>
      <p className="wg-empty__copy">
        The link may be out of date, or you may not have access to this watch.
      </p>
      <Button component={Link} to="/login" variant="contained">
        Back to sign in
      </Button>
    </div>
  </main>
);

export default NotFound;
